export const userAccount = {
  marketingConsentLabel:
    "If you don't want to receive premium offers, new recipes & product updates, tick this box.",
};
